export class VehicleInspectionThresholdQueryParameters {
  id?: string;
  greenThresholdValue?: number;
  inspectionTypeId?: number;
  maxValue?: number;
  minValue?: number;
  page?: number;
  pageSize?: number;
  redThresholdValue?: number;
  thresholdName?: string;
  thresholdOperator?: string;
  vehicleInspectionTasksId?: number;
  yellowThresholdValue?: number;

  constructor(obj?: VehicleInspectionThresholdQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
